export default __webpack_public_path__ + "static/media/good-interaction.93528908.svg";